import { defineMessages } from 'react-intl';

export default defineMessages({
  'Сторінку не знайдено': {
    id: 'notFound:seo_title',
    defaultMessage: 'Сторінку не знайдено',
  },
  'Вибачте, але сторінки, що Ви намагалися переглянути, не існує.': {
    id: 'notFound:descr',
    defaultMessage:
      'Вибачте, але сторінки, що Ви намагалися переглянути, не існує.',
  },
});
